
  import { css } from 'lit';
  export const styles = css`:host{--disabled-color: var(--ig-icon-disabled-color, var(--ig-gray-500));--ig-theme: fluent;--ig-theme-variant: dark}`;
  